import { httpClient } from "@/lib/http";
import { ANALYTICS_ENDPOINTS } from "@/config/api";
import type { ApiResponse } from "@/types/api";
import type {
    AnalyticsDateRange,
    HourlyRevenueQueryParams,
    RevenueAnalyticsResponse,
    HourlyRevenueResponse,
    TripAnalyticsResponse,
    CancellationAnalyticsResponse,
    UserAnalyticsResponse,
    DriverAnalyticsResponse,
    GeographicAnalyticsResponse,
    RegionalAnalyticsResponse,
    AnalyticsSummaryResponse,
    OperationalAnalyticsResponse,
    QualityAnalyticsResponse,
} from "../types";

// ============================================================================
// Revenue
// ============================================================================

export const getRevenueAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<RevenueAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<RevenueAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.REVENUE,
        { params }
    );
    return response.data;
};

export const getHourlyRevenue = async (
    params?: HourlyRevenueQueryParams
): Promise<ApiResponse<HourlyRevenueResponse>> => {
    const response = await httpClient.get<ApiResponse<HourlyRevenueResponse>>(
        ANALYTICS_ENDPOINTS.REVENUE_HOURLY,
        { params }
    );
    return response.data;
};

// ============================================================================
// Trips
// ============================================================================

export const getTripAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<TripAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<TripAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.TRIPS,
        { params }
    );
    return response.data;
};

export const getCancellationAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<CancellationAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<CancellationAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.CANCELLATIONS,
        { params }
    );
    return response.data;
};

// ============================================================================
// Users
// ============================================================================

export const getUserAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<UserAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<UserAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.USERS,
        { params }
    );
    return response.data;
};

export const getDriverAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<DriverAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<DriverAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.DRIVERS,
        { params }
    );
    return response.data;
};

// ============================================================================
// Geographic
// ============================================================================

export const getGeographicAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<GeographicAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<GeographicAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.GEOGRAPHIC,
        { params }
    );
    return response.data;
};

export const getRegionalAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<RegionalAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<RegionalAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.REGIONS,
        { params }
    );
    return response.data;
};

// ============================================================================
// Operational
// ============================================================================

export const getOperationalAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<OperationalAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<OperationalAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.OPERATIONAL,
        { params }
    );
    return response.data;
};

// ============================================================================
// Quality
// ============================================================================

export const getQualityAnalytics = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<QualityAnalyticsResponse>> => {
    const response = await httpClient.get<ApiResponse<QualityAnalyticsResponse>>(
        ANALYTICS_ENDPOINTS.QUALITY,
        { params }
    );
    return response.data;
};

// ============================================================================
// Summary
// ============================================================================

export const getAnalyticsSummary = async (
    params?: AnalyticsDateRange
): Promise<ApiResponse<AnalyticsSummaryResponse>> => {
    const response = await httpClient.get<ApiResponse<AnalyticsSummaryResponse>>(
        ANALYTICS_ENDPOINTS.SUMMARY,
        { params }
    );
    return response.data;
};
